/* eslint-disable @typescript-eslint/no-explicit-any */
import React, {useEffect} from 'react';
import {Linking, View} from 'react-native';
import SubmitButtons from '../../../components/Button/SecondaryButton';
import {InputField} from '../../../components/Inputs/InputField';

import 'dayjs/locale/fr';
import {useState} from 'react';
import {Validation} from '../../../../common/utils/validationSouscriptionRCVP';
import url from '../../../../data/config';
import {TitleLabels} from '../../../../data/constants/Assurance/assuranceRCVP';
import {handleGetCurrentDateEffet} from '../../../../data/factory';
import {useForm} from '../../../../hooks/AssuranceRCVP/useForm';
import CheckBoxComponent from '../../../components/Inputs/Checkbox';
import {InputDatePicker} from '../../../components/Inputs/InputDatePicker';
import {InputPhoneNumber} from '../../../components/Inputs/InputPhoneNumber/index.web';
import Select from '../../../components/Inputs/Select';

export const Form = (props: any) => {
  const {
    data,
    listAgence,
    onCancelForm,
    onSubmitForm,
    isRenewal,
    minDateEffect,
  } = props;

  const {handleChange, handleSubmit, values, errors, showErrors, dto} = useForm(
    data,
    Validation,
    handleSave,
    listAgence,
  );

  const [isDisable, setIsDisable] = useState(false);

  function handleCancel() {
    onCancelForm();
  }

  function handleSave() {
    dto.data.dateEffet = handleGetCurrentDateEffet(dto.data.dateEffet);
    dto.data.primeTTC = dto.data.primeTTC.split(' ').join('');
    dto.data.nombreAnimauxDomestique = dto.data.nombreAnimauxDomestique
      .split(' ')
      .join('');

    onSubmitForm(dto.data);
  }

  const showTermsOfUse = () => {
    Linking.openURL(url.rcvpPdf);
  };

  useEffect(() => {
    if (data.primeTTC) {
      handleChange('primeTTC', data.primeTTC, true);
    }
  }, [data.primeTTC]);

  return (
    <View>
      <View>
        <InputField
          label={TitleLabels.contractant.nomPrenomContractant}
          required
          value={values.nomPrenomContractant}
          name="nomPrenomContractant"
          onChange={handleChange}
          error={errors.nomPrenomContractant}
          showError={showErrors.nomPrenomContractant}
          maxLength={70}
          isEditable={false}
        />
        <InputField
          label={TitleLabels.contractant.dateNaissanceContractant}
          required
          name="dateNaissanceContractant"
          value={values.dateNaissanceContractant}
          onChange={handleChange}
          error={errors.dateNaissanceContractant}
          showError={showErrors.dateNaissanceContractant}
          maxLength={100}
          isEditable={false}
        />
        <InputPhoneNumber
          label={TitleLabels.contractant.telephoneContractant}
          required
          name="telephoneContractant"
          type="telephone"
          value={values.telephoneContractant}
          onChange={handleChange}
          error={errors.telephoneContractant}
          showError={showErrors.telephoneContractant}
          isEditable={false}
          country={values?.telephoneContractantCountryCode || 'MG'}
        />
        <InputField
          label={TitleLabels.contractant.emailContractant}
          required
          name="emailContractant"
          value={values.emailContractant}
          onChange={handleChange}
          error={errors.emailContractant}
          showError={showErrors.emailContractant}
          maxLength={100}
          isEditable={false}
        />

        <InputField
          label={TitleLabels.contractant.nombreAnimauxDomestique}
          required
          type="price"
          name="nombreAnimauxDomestique"
          value={values.nombreAnimauxDomestique}
          onChange={handleChange}
          error={errors.nombreAnimauxDomestique}
          showError={showErrors.nombreAnimauxDomestique}
          maxLength={10}
        />
        <InputField
          label={TitleLabels.contractant.adresse}
          required
          name="adresse"
          value={values.adresse}
          onChange={handleChange}
          error={errors.adresse}
          showError={showErrors.adresse}
          maxLength={50}
          isEditable={false}
        />
        <InputDatePicker
          label={TitleLabels.contractant.dateEffet}
          required
          value={values.dateEffet}
          name="dateEffet"
          onChange={handleChange}
          dateMin={minDateEffect}
        />
        <Select
          data={
            listAgence.length
              ? [
                  {label: 'Choisir Agence', value: ''},
                  ...listAgence.map((element: any) => ({
                    label: element.label,
                    value: element.value,
                  })),
                ]
              : []
          }
          label={TitleLabels.contractant.agence}
          defaultValue={values.agence}
          required={true}
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          onChange={(name: string, data: any, fired: boolean) => {
            handleChange('agence', data, true);
          }}
          value={values.agence}
          error={errors.agence}
          showError={showErrors.agence}
          disabled={isRenewal}
        />
        <InputField
          label={TitleLabels.contractant.primeTTC}
          type="price"
          isEditable={false}
          required
          name="primeTTC"
          value={values.primeTTC}
          onChange={handleChange}
          error={errors.primeTTC}
          showError={showErrors.primeTTC}
        />
        {/** Submit buttons */}
        <CheckBoxComponent
          changeValue={setIsDisable}
          value={isDisable}
          onPress={() => showTermsOfUse()}
        />
      </View>
      <View style={{marginTop: -20, marginBottom: 50}}>
        <SubmitButtons
          isDisable={!isDisable}
          cancelAction={handleCancel}
          submitAction={handleSubmit}
          cancelTitle="Annuler"
          submitTitle="Valider"
        />
      </View>
    </View>
  );
};
